export const INIT_SOCKET_IO = "[Socket Init] Initiate our socket io";
export const CHANGE_CONNECTION_STATE =
  "[Socket Connection] Change connection status of socket io";
export const UPDATE_EVENT_STACK =
  "[Socket Event] Update the top of event stack";
